import { render, staticRenderFns } from "./mianView.vue?vue&type=template&id=32c0c71a&scoped=true"
import script from "./mianView.vue?vue&type=script&lang=js"
export * from "./mianView.vue?vue&type=script&lang=js"
import style0 from "./mianView.vue?vue&type=style&index=0&id=32c0c71a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0c71a",
  null
  
)

export default component.exports